import React, { useState } from 'react';
import api from '../../utils/api';
import Button from '../UI/Button';
import Input from '../UI/Input';

export default function AssignmentSubmit({ assignmentId, onSuccess, onCancel }) {
  const [formData, setFormData] = useState({
    content: '',
    fileUrl: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.content.trim()) {
      newErrors.content = '과제 내용을 입력해주세요.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);
      const response = await api.post(`/api/assignments/${assignmentId}/submit`, formData);

      if (response.data.success) {
        onSuccess();
      }
    } catch (err) {
      const errorMsg = err.response?.data?.error || '과제 제출에 실패했습니다.';
      setErrors({ submit: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          과제 내용
          <span className="text-danger-500 ml-1">*</span>
        </label>
        <textarea
          name="content"
          value={formData.content}
          onChange={handleChange}
          className="w-full px-4 py-2.5 rounded-xl border-2 border-neutral-200 focus:border-primary-500 focus:outline-none transition-colors duration-200 min-h-[200px]"
          placeholder="과제 내용을 입력하세요..."
        />
        {errors.content && (
          <p className="mt-1.5 text-sm text-danger-500">{errors.content}</p>
        )}
      </div>

      <Input
        label="첨부 파일 URL (선택사항)"
        name="fileUrl"
        value={formData.fileUrl}
        onChange={handleChange}
        error={errors.fileUrl}
        placeholder="https://example.com/file.pdf"
        helper="파일을 다운로드할 수 있는 링크를 입력하세요."
      />

      {errors.submit && (
        <div className="p-4 bg-danger-50 border border-danger-200 rounded-xl">
          <p className="text-sm text-danger-600">{errors.submit}</p>
        </div>
      )}

      <div className="flex gap-3 pt-4">
        <Button type="submit" disabled={loading} className="flex-1">
          {loading ? '제출 중...' : '제출하기'}
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={loading}
        >
          취소
        </Button>
      </div>
    </form>
  );
}
